export const COVERED_URI = 'https://newquote.itscovered.com/homebot'
